import axios from '../utils/axios';

export default function getProMemberShipInvoiceCreditNotesList(adminId, params, isDownload) {
    return axios.get(`/admin/${adminId}/jobseeker-admin/v2/admin/invoice/viewIcnList`, { params, responseType: isDownload ? 'blob' : 'json' });
};
